<template>
  <Modal
    data-testid="password-dialog"
    title="Confirmação por senha"
    size="md"
    is-open
    @close="close"
  >
    <InputPassword
      v-model="password"
      label="Senha"
      data-testid="input-password"
    />
    <template #buttons>
      <ModalButton @click="handleCancel">Cancelar</ModalButton>
      <ModalButton :disabled="isButtonConfirmDisabled" @click="handleConfirm">
        Confirmar
      </ModalButton>
    </template>
  </Modal>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ModalButton, Modal, InputPassword } from '@warrenbrasil/nebraska-web';

@Component({ components: { InputPassword, Modal, ModalButton } })
export default class PasswordDialog extends Vue {
  @Prop({ required: true, type: Function }) private cancel!: (
    msg: string
  ) => string;

  @Prop({ required: true, type: Function }) private close!: () => void;
  @Prop({ required: true, type: Function }) private confirm!: (
    password: string
  ) => string;

  private isButtonConfirmDisabled = true;
  private password = '';

  @Watch('password')
  private updateButton() {
    this.isButtonConfirmDisabled = this.password === '';
  }

  private handleConfirm() {
    this.close();
    return this.confirm(this.password);
  }

  private handleCancel() {
    this.close();
    return this.cancel('Nenhuma alteração foi salva');
  }
}
</script>
